import { createSelector } from 'reselect'

import { currentInviteeSelector } from 'selectors/current_invitee'

export const trackingSelector = createSelector(
  (state) => state.tracking,
  currentInviteeSelector,
  (tracking, invitee) => ({
    ...(invitee?.tracking || {}),
    ...(tracking || {})
  })
)
